import styled from 'styled-components';

export const Invisible = styled.div`
  opacity: 0;
  height: 0;
  width: 0;
  input {
    width: 1px;
  }
`;
